import React, { useState, useEffect, useReducer, useRef } from "react";
import { useStore } from "@nanostores/react";
import { useHistory } from "react-router-dom";
import Hero from "./component/Hero";
import Features from "./component/Features";
import Footer from "./component/Footer";

import {
  Flex,
  Button,
  Icon,
  Text,
  useColorMode,
  useColorModeValue,
  Image,
  Box,
  Link,
  Spacer,
} from "@chakra-ui/react";
import { FaHome, FaSignInAlt } from "react-icons/fa";
import { useDropzone } from "react-dropzone";
import Contact from "./component/ContactUs";
import Pricing from "./component/Pricing";
import logo from "assets/img/logo.png";

import { userProfile } from "contexts/userProfile.js";

const reducer = (state, action) => {
  if (action.type === "SWITCH_ACTIVE") {
    if (action.payload === "overview") {
      const newState = {
        overview: true,
        teams: false,
        projects: false,
      };
      return newState;
    } else if (action.payload === "teams") {
      const newState = {
        overview: false,
        teams: true,
        projects: false,
      };
      return newState;
    } else if (action.payload === "projects") {
      const newState = {
        overview: false,
        teams: false,
        projects: true,
      };
      return newState;
    }
  }
  return state;
};

function Home() {
  const { auth } = useStore(userProfile);

  const [state, dispatch] = useReducer(reducer, {
    overview: true,
    teams: false,
    projects: false,
  });

  const [activeBullets, setActiveBullets] = useState({
    productInfo: true,
    media: false,
    socials: false,
    pricing: false,
  });

  const productInfoTab = useRef();
  const mediaTab = useRef();
  const socialsTab = useRef();
  const pricingTab = useRef();

  const { getRootProps, getInputProps } = useDropzone();
  const { colorMode } = useColorMode();
  const textColor = useColorModeValue("gray.700", "white");
  const bgProfile = useColorModeValue("hsla(0,0%,100%,.8)", "navy.800");
  const borderProfileColor = useColorModeValue("white", "transparent");
  const bgPrevButton = "gray.100";
  const history = useHistory();

  return (
    <Flex
      direction="column"
      h="100%"
      maxW="1400px"
      margin="auto"
      minH="100vh"
      bgSize="cover"
      bgRepeat="no-repeat"
    >
      <Flex
        as="nav"
        align="center"
        justify="space-between"
        wrap="wrap"
        py={0}
        h="100px"
        bg="transparent"
        color="white"
      >
        <Flex align="center">
          <Image src={logo} height="80px" objectFit="contain" alt="CogniSigner Logo" />
        </Flex>

        <Spacer />

        <Button
          bg="transparent"
          leftIcon={auth ? <FaHome /> : <FaSignInAlt />}
          onClick={() => {
            history.push(auth ? "/admin/dashboard" : "/auth/sign-in");
          }}
        />
      </Flex>
      <Hero />
      <Features />
      <Pricing />
      <Contact />
      <Footer />
    </Flex>
  );
}

export default Home;
